import { createEnv } from '@t3-oss/env-nextjs'
import { z } from 'zod'

export const env = createEnv({
  client: {
    NEXT_PUBLIC_OTP_GEN_TIMOUT_IN_SECONDS: z.coerce
      .number()
      .min(20)
      .default(25),
    NEXT_PUBLIC_FORMS_TO_DISPLAY_PER_CARD: z.coerce.number().min(1).default(4),
    NEXT_PUBLIC_OTP_LENGTH: z.coerce.number().min(3).default(6),
    NEXT_PUBLIC_TNC_URL: z.string().url().default('https://www.hdfcbank.com'),
    NEXT_PUBLIC_ENCRYPTION_STATE: z.string().default('true'),
    NEXT_PUBLIC_KNOW_MORE_URL: z
      .string()
      .url()
      .default('https://www.hdfcbank.com'),

    // TO-DO: See if I can make it non public since public variables get inline
    NEXT_PUBLIC_PUBLIC_KEY: z.string().default('encryption-key'),

    NEXT_PUBLIC_INSTASERVICES_URL: z
      .string()
      .url()
      .default(
        'https://www.hdfcbank.com/personal/resources/ways-to-bank/online-banking/insta-services'
      ),
    NEXT_PUBLIC_GOLD_LOAN: z
      .string()
      .url()
      .default(
        'https://www.hdfcbank.com/personal/borrow/loan-against-assets/gold-loan'
      ),
    NEXT_PUBLIC_NRI_INSURANCE_LOAN: z
      .string()
      .url()
      .default(
        'https://www.hdfcbank.com/personal/insure/life-insurance/protect-life'
      ),
    NEXT_PUBLIC_NR_CUSTOMER: z
      .string()
      .url()
      .default(
        'https://www.hdfcbank.com/personal/resources/rates#/Important-Notes:-NRI-Customers'
      ),
    NEXT_PUBLIC_OTHER_O_CATEGORY_CUSTOMER: z
      .string()
      .url()
      .default(
        'https://www.hdfcbank.com/personal/resources/rates#/Important-Notes:-Resident-Customers'
      ),
    NEXT_PUBLIC_NR_AVERAGE_MONTHLY_BALANCE: z
      .string()
      .url()
      .default(
        'https://www.hdfcbank.com/nri-banking/save/nri-accounts/savings-account/fees-and-charges'
      ),
    NEXT_PUBLIC_LOG_ENCRYPTION_VALUE: z
      .string()
      .min(1)
      .default('jS8GlzNUO4Pf4Ii8IDQktJQfaMYrcGBfMQMvbDO1xmk='),
  },
  runtimeEnv: {
    NEXT_PUBLIC_OTP_GEN_TIMOUT_IN_SECONDS:
      process.env.NEXT_PUBLIC_OTP_GEN_TIMOUT_IN_SECONDS,
    NEXT_PUBLIC_FORMS_TO_DISPLAY_PER_CARD:
      process.env.NEXT_PUBLIC_FORMS_TO_DISPLAY_PER_CARD,
    NEXT_PUBLIC_OTP_LENGTH: process.env.NEXT_PUBLIC_OTP_LENGTH,
    NEXT_PUBLIC_TNC_URL: process.env.NEXT_PUBLIC_TNC_URL,
    NEXT_PUBLIC_PUBLIC_KEY: process.env.NEXT_PUBLIC_PUBLIC_KEY,
    NEXT_PUBLIC_INSTASERVICES_URL: process.env.NEXT_PUBLIC_INSTASERVICES_URL,
    NEXT_PUBLIC_ENCRYPTION_STATE: process.env.NEXT_PUBLIC_ENCRYPTION_STATE,
    NEXT_PUBLIC_KNOW_MORE_URL: process.env.NEXT_PUBLIC_KNOW_MORE_URL,
    NEXT_PUBLIC_GOLD_LOAN: process.env.NEXT_PUBLIC_GOLD_LOAN,
    NEXT_PUBLIC_NRI_INSURANCE_LOAN: process.env.NEXT_PUBLIC_NRI_INSURANCE_LOAN,
    NEXT_PUBLIC_NR_CUSTOMER: process.env.NEXT_PUBLIC_NR_CUSTOMER,
    NEXT_PUBLIC_OTHER_O_CATEGORY_CUSTOMER:
      process.env.NEXT_PUBLIC_OTHER_O_CATEGORY_CUSTOMER,
    NEXT_PUBLIC_NR_AVERAGE_MONTHLY_BALANCE:
      process.env.NEXT_PUBLIC_NR_AVERAGE_MONTHLY_BALANCE,
    NEXT_PUBLIC_LOG_ENCRYPTION_VALUE:
      process.env.NEXT_PUBLIC_LOG_ENCRYPTION_VALUE,
  },
})
